import ctx from "@/ctx";
import fetch from "./fetch";

export function extractServiceFromRow(d) {
  const rawService = d.service;
  const nested =
    rawService != null && typeof rawService === "object" ? rawService : null;
  const primitiveId =
    rawService != null &&
    typeof rawService !== "object" &&
    !Number.isNaN(Number(rawService))
      ? rawService
      : null;
  const primitiveName =
    rawService != null &&
    typeof rawService === "string" &&
    Number.isNaN(Number(rawService))
      ? rawService
      : null;

  const id =
    d.serviceId != null
      ? d.serviceId
      : primitiveId != null
        ? primitiveId
        : nested && nested.id;

  const name =
    d.serviceName ||
    d.serviceString ||
    primitiveName ||
    (nested &&
      (nested.name ||
        nested.serviceName ||
        nested.fullName ||
        nested.serviceString));

  return { id, name };
}

export function addToServiceLookup(lookup, service) {
  if (!service || service.id == null) return;
  lookup[service.id] = service;
  lookup[String(service.id)] = service;
}

export function getServiceFromLookup(lookup, id) {
  if (id == null || id === "") return null;
  if (lookup) {
    const fromLookup = lookup[id] || lookup[String(id)];
    if (fromLookup) return fromLookup;
  }
  return ctx.src.services.get(id) || null;
}

export function createService2vm(serviceLookup, apiServiceId, apiServiceName) {
  return function(val) {
    const serviceId = val != null ? val : apiServiceId;
    if (serviceId == null) return {};
    const service = getServiceFromLookup(serviceLookup, serviceId);
    if (service) return service;
    if (apiServiceName) return { id: serviceId, name: apiServiceName };
    return {};
  };
}

export function applyServiceName4List(
  self,
  d,
  serviceLookup,
  apiServiceId,
  apiServiceName
) {
  const serviceName =
    d.serviceName ||
    d.serviceName4List ||
    (self.service && self.service.name) ||
    apiServiceName ||
    (serviceLookup &&
      self.serviceId != null &&
      getServiceFromLookup(serviceLookup, self.serviceId) &&
      getServiceFromLookup(serviceLookup, self.serviceId).name) ||
    "";
  self.serviceName4List = serviceName;
  if ((!self.service || !self.service.name) && serviceName) {
    self.service = { id: self.serviceId || apiServiceId, name: serviceName };
  }
  return serviceName;
}

export async function ensureServicesCatalog() {
  if (ctx.src.services && ctx.src.services.init) {
    await ctx.src.services.init();
  }
}

export function augmentServiceLookupFromRows(lookup, rows) {
  (rows || []).forEach(row => {
    const { id, name } = extractServiceFromRow(row);
    if (id != null && name) {
      addToServiceLookup(lookup, { id, name });
    }
  });
  return lookup;
}

export async function buildServiceLookup({
  insuredIds = [],
  extraServices = [],
  rows = []
} = {}) {
  await ensureServicesCatalog();
  const lookup = {};
  (ctx.src.services.items || []).forEach(s => addToServiceLookup(lookup, s));
  (extraServices || []).forEach(s => addToServiceLookup(lookup, s));
  augmentServiceLookupFromRows(lookup, rows);

  const uniqueInsuredIds = [
    ...new Set(
      [...insuredIds, ...(rows || []).map(r => r.insuredId)].filter(
        id => id != null
      )
    )
  ];
  await Promise.all(
    uniqueInsuredIds.map(insuredId =>
      fetch
        .get(
          "/api/accounting/services/get-active-services?insuredId=" + insuredId
        )
        .then(activeServices =>
          (activeServices || []).forEach(s => addToServiceLookup(lookup, s))
        )
        .catch(() => {})
    )
  );
  return lookup;
}

export async function fillMissingServicesInLookup(lookup, rows) {
  const missingIds = new Set();
  (rows || []).forEach(row => {
    const { id, name } = extractServiceFromRow(row);
    if (id == null) return;
    if (name) {
      addToServiceLookup(lookup, { id, name });
      return;
    }
    const existing = getServiceFromLookup(lookup, id);
    if (!existing || !existing.name) {
      missingIds.add(id);
    }
  });
  if (missingIds.size === 0) return lookup;

  const query = [...missingIds].map(id => "ids=" + id).join("&");
  const services = await fetch
    .get("/api/accounting/services/get-by-ids?" + query)
    .catch(() => null);
  (services || []).forEach(s => addToServiceLookup(lookup, s));
  return lookup;
}
